<!-- 兑换记录 -->
<template>
  <div class="content">
    <div class="bodycontent">
      <div class="top">
        <div>
          <router-link to="optionTicket">
            <el-button type="primary" icon="el-icon-plus" size="small">
              新增优惠券
            </el-button>
          </router-link>
        </div>
        <div style="display:flex;: center;align-items: center;">
          <el-select v-model="screenInput" placeholder="优惠券类型" size="mini">
            <!-- 1：满减2：折扣3：代金4：兑换5：储值6：通用7：次数券 -->
            <el-option
              v-for="(item, index) in typeData"
              :label="item.name"
              :key="index"
              :value="item.index"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="cont">
        <ul class="left">
          <li>类型</li>
          <li
            v-for="(item, index) in typeData"
            :key="index"
            @click="change(item.index)"
            :class="couponType == item.index ? 'current' : ''"
          >
            {{ item.name }}
          </li>
        </ul>
        <div class="right">
          <el-table
            :data="tableData"
            :header-cell-style="setHeader"
            style="width: 100%; height: 100%;"
          >
            <!-- <el-table-column label="优惠券分享图">
              <template slot-scope="scope">
                <img
                  :src="scope.row.share_pic"
                  alt=""
                  style="width:50px; height: auto"
                />
              </template>
            </el-table-column> -->
            <el-table-column prop="title" label="优惠券名称"> </el-table-column>
            <el-table-column label="类型">
              <template slot-scope="scope">
                <div v-if="scope.row.type == 1">满减</div>
                <div v-if="scope.row.type == 2">折扣</div>
                <div v-if="scope.row.type == 3">代金</div>
                <div v-if="scope.row.type == 4">兑换</div>
                <div v-if="scope.row.type == 5">储值</div>
                <div v-if="scope.row.type == 6">通用</div>
                <div v-if="scope.row.type == 7">次数券</div>
              </template>
            </el-table-column>
            <el-table-column label="可领取时间">
              <template slot-scope="scope">
                {{ scope.row.get_start_time }} - {{ scope.row.get_end_time }}
              </template>
            </el-table-column>
            <el-table-column label="可领取用户">
              <template slot-scope="scope">
                <div v-if="scope.row.user_limit == 0">所有用户</div>
                <div v-if="scope.row.user_limit == 1">所有会员</div>
                <div v-if="scope.row.user_limit == 2">指定会员</div>
              </template>
            </el-table-column>
            <el-table-column prop="stock" label="库存"> </el-table-column>
            <!-- <el-table-column label="能否转增">
              <template slot-scope="scope">
                <span v-if="scope.row.is_send == 0"> 不可转赠</span>
                <span v-else> 可转赠</span>
              </template>
            </el-table-column> -->
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button size="mini" @click="handle(1, scope.row.id)"
                  >编辑</el-button
                >
                <el-button size="mini" @click="handle(0, scope.row.id)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="page">
            <el-pagination
              @current-change="handleCurrentChange"
              layout="total, prev, pager, next, jumper"
              :total="total_num"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { couponList, deletecoupon } from "@/api/coupon";
import { mapGetters } from "vuex";
export default {
  inject: ["reload"],
  computed: {
    ...mapGetters(["app_id", "token"])
  },
  data() {
    return {
      couponType: "0",
      total_num: 0,
      page: "",
      data: "",
      screenInput: "",
      headerStyle: {
        background: "rgba(250,250,250,1)",
        color: "#000000"
      },
      tableData: [],
      typeData: [
        {
          name: "全部",
          index: 0
        },
        {
          name: "满减",
          index: 1
        },
        {
          name: "折扣",
          index: 2
        },
        {
          name: "代金",
          index: 3
        },
        {
          name: "兑换",
          index: 4
        },
        {
          name: "储值",
          index: 5
        },
        {
          name: "通用",
          index: 6
        },
        {
          name: "次数券",
          index: 7
        }
      ]
    };
  },

  components: {},
  mounted() {
    this.getList();
  },
  methods: {
    // change
    change(index) {
      this.couponType = index;
      this.getList();
    },
    // 设置表头颜色
    setHeader({ rowIndex }) {
      if (rowIndex === 0) {
        return this.headerStyle;
      } else {
        return "";
      }
    },
    // 筛选
    screen() {
      console.log("screenInput", this.screenInput);
      let data = {
        token: this.token,
        app_id: this.app_id,
        type: this.screenInput,
        store_id: 0 //
      };
      couponList(data).then(res => {
        console.log("订单列表", res);
        this.tableData = res.data.result;
      });
    },
    getList() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page,
        type: this.couponType, //类型
        is_exp: 0
      };
      couponList(data).then(res => {
        console.log("订单列表", res);
        this.tableData = res.data.result;
        this.total_num = res.data.total_num;
      });
    },
    // 操作 type 1 编辑 0 删除 index =>对应商品id
    handle(type, index) {
      if (type == 1) {
        this.$router.push({ name: "optionTicket", query: { idE: index } });
      } else {
        let data = {
          token: this.token,
          app_id: this.app_id,
          store_id: 0, //
          id: index
        };
        this.$confirm("删除是不可逆的，请谨慎删除?！！！", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "danger"
        })
          .then(() => {
            deletecoupon(data).then(res => {
              console.log("shanchu ", res);
              if (res.code == 200) {
                this.$message.success(res.msg);
                this.reload();
              } else {
                this.$message("删除失败");
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      }
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getList();
    }
  }
};
</script>
<style lang="scss" scoped>
// @import "./public/style/_interfacePublic";
.flex {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.padding {
  padding: 20px;
}
.content {
  // width: 100%;
  height: 100%;
  padding: 0 55px 30px 30px;

  .bodycontent {
    height: 100%;
    .top {
      height: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .cont {
      width: 100%;
      height: calc(100% - 60px);
      display: flex;
      .left {
        width: 140px;
        margin-right: 15px;
        border: 1px solid #ebeef5;
        li {
          width: 100%;
          line-height: 50px;
          padding: 0 15px;
          border-bottom: 1px solid #ebeef5;
          cursor: pointer;
        }
        li:first-child {
          background: #fafafa;
        }
        .current {
          background: #fafafa;
        }
      }
      .right {
        flex: 1;
        display: flex;
        overflow: hidden;
        flex-direction: column;
        .page {
          height: 50px;
          display: flex;
          align-items: center;
        }
        .el-table {
          flex: 1;
          overflow-y: auto;
        }
      }
    }
  }
}
</style>
